import 'hammerjs';
import { enableProdMode } from '@angular/core';
import './app/ag-grid-setup';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
declare global {
  interface Window {
    Rakanto: any;
  }
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
